import { getMenu } from "../services/menu/menu.service";
export const actions = {
  async setMenuStore({ commit }) {
    try {
      const menu = await getMenu();
      commit("addMenu", menu);
    } catch {
      if (process.env.NODE_ENV !== "production") {
        console.error("Cannot fetch menu, please log in again");
      }
    }
  },
  async fetchAuthentication({ commit }, isSuccess) {
    commit("updateAuthentication", isSuccess);
  },
  async fetchSecret({ commit }, secret) {
    commit("updateSecret", secret);
  },
  async fetchUserManagement({ commit }, userManagement) {
    commit("updateUserManagement", userManagement);
  },
  async fetchPermissions({ commit }, permissions) {
    commit("updatePermissions", permissions);
  },
};
